import * as Sentry from "@sentry/react";
import React from "react";
import { useLocation, useNavigationType, createRoutesFromChildren, matchRoutes } from "react-router-dom";


export const initializeSentry = (isProduction: boolean) => {
    if (isProduction) {
        Sentry.init({
            dsn: "https://8051670e3c7effd04535d6d3334a286b@o4507206156419072.ingest.de.sentry.io/4508842081124432",
            integrations: [
                Sentry.browserTracingIntegration(),
                Sentry.replayIntegration({
                    maskAllText: false,
                    maskAllInputs: false,
                    blockAllMedia: false,
                }),
                Sentry.reactRouterV6BrowserTracingIntegration({
                    useEffect: React.useEffect,
                    useLocation,
                    useNavigationType,
                    createRoutesFromChildren,
                    matchRoutes,
                }),
            ],

            tracesSampleRate: 1.0,
            replaysSessionSampleRate: 0.1,
            replaysOnErrorSampleRate: 1.0,
            tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
        });
    } else {
        console.log('Sentry not initialized in development mode')
    }
}